interface Props {
  style: React.CSSProperties;
  className?: string;
}

export function DiffusionModelsTableRowLoading({ style, className = '' }: Props) {
  return (
    <div style={{ ...style }} className={`flex items-center pl-10 justify-start border-b border-dashed border-component-border ${className}`}>
      <span className="text-lg text-page-foreground">Loading...</span>
    </div>
  );
}
